import domainConfigs from '@/config/domain'
import { useCurrentUser } from '@/features/auth/state/auth'

export default function useTenantsConfigByUser() {
  const user = useCurrentUser()
  const tenantsConfig = Object.entries(domainConfigs)
    .filter(([key]) => key !== 'default')
    .map(([_, value]) => value)

  if (!user) {
    return null
  }

  if (user.typeUser === 'ADMIN') {
    return tenantsConfig
  }

  return tenantsConfig
}
